<template>
    <add-edit-service></add-edit-service>
</template>

<script>
import AddEditService from "@/layouts/components/masters/services/addedit-services.vue";
export default {
 components : {
   AddEditService
 },
};
</script>